// extracted by mini-css-extract-plugin
export default {"profileLoader":"ProfilePage_profileLoader__XHJUs"};